// Styles
import IframeContainer from "./IframeContainer.styles";
import PowerBIDashboard from "../../components/Common/PowerBIDashboard";
import React from "react";

type Props = {
    reportId: string;
    workspaceId: string;
};

export default function UsageStatSummary({ reportId, workspaceId }: Props) {
    return (
        <IframeContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId={reportId}
                    workspaceId={workspaceId}
                ></PowerBIDashboard>
            </div>
        </IframeContainer>
    );
}
